import React, {FunctionComponent, useState} from 'react';
import {FormattedMessage, useIntl} from 'react-intl';
import {Link} from 'react-router-dom';

import {RoutesUrl} from 'utils/constants/routeConstants';

import './styles.scss';

const SUPPORT_EMAIL = 'support@mira-now.com';

export const AdditionalInformation: FunctionComponent = () => {
  const intl = useIntl();
  const [isCopied, setIsCopied] = useState(false);

  async function copySupportEmail() {
    try {
      await navigator.clipboard.writeText(SUPPORT_EMAIL);
    } catch {
      return;
    }
    setIsCopied(true);
    setTimeout(() => setIsCopied(false), 2000);
  }

  return <div className="additional-information-color">
    <div className="additional-information__wrap">
      <div className="additional-information__foot">
        <div className="additional-information__about">
          <FormattedMessage
            id={'gritx.footer.about.description'}
            defaultMessage={'Mira Now is a private space for your health and wellbeing, powered by Scalable Care.'}
          />
        </div>
        <p className="additional-information__copyright">
          <FormattedMessage
            id={'gritx.footer.copyrightMira'}
            defaultMessage={'© {year} Scalable Care, a WSC Technology, Inc. company. All rights reserved.'}
            values={{year: new Date().getFullYear()}}
          />
        </p>
        <p className="additional-information__support">
          <span className="additional-information__support-label">
            <FormattedMessage id={'gritx.footer.support.label'} defaultMessage={'Support:'}/>
          </span>
          <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>
          <button
            type="button"
            className="additional-information__copy-btn"
            onClick={copySupportEmail}
            aria-label={intl.formatMessage({id: 'gritx.footer.support.copy', defaultMessage: 'Copy email address'})}
          >
            <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <rect x="9" y="9" width="12" height="12" rx="2"/>
              <path d="M5 15V5a2 2 0 0 1 2-2h10"/>
            </svg>
          </button>
          <span className={`additional-information__copied${isCopied ? ' additional-information__copied--visible' : ''}`}>
            <FormattedMessage id={'gritx.footer.support.copied'} defaultMessage={'Copied!'}/>
          </span>
        </p>
        <div className="additional-information__links">
          <Link to={RoutesUrl.Privacy}>
            <FormattedMessage id={'gritx.footer.links.privacy'} defaultMessage={'Privacy'}/>
          </Link>
          <Link to={RoutesUrl.TermsOfUse}>
            <FormattedMessage id={'gritx.footer.links.terms'} defaultMessage={'Terms of Use'}/>
          </Link>
          <a href="https://www.scalable.care/" target="_blank" rel="noopener noreferrer">
            <FormattedMessage id={'gritx.footer.links.scalableCare'} defaultMessage={'scalable.care'}/>
          </a>
        </div>
      </div>
    </div>
  </div>;
};
